import React, { useContext } from "react";
import config from "../../config";
import { Container, Row, Col } from "react-bootstrap";
import "../../generalPages/generalCSS/footer.css";
import { Link } from "react-router-dom";
import GoogleTranslate from '../../GoogleTranslate';
import Cookies from "js-cookie";
import { Widgets } from "@mui/icons-material";
import { CurrencyContext } from "../../currencyConvertor/CurrencyContext";

const loginData = !Cookies.get("loginSuccessPropertyOwner")
  ? []
  : JSON.parse(Cookies.get("loginSuccessPropertyOwner"));



const Footer = () => {
  const { currency, setCurrency } = useContext(CurrencyContext);

  return (
    <>
      <footer className="bg-white pt-5 pb-2  border-top">
        <Container>
          <Row>
            <Col lg={3} className="mb-3">
              <div className="f-logo mb-3">
                <img src="assets/images/logo/logo.webp" />
              </div>
              <p>Bringing it all together</p>
              <div className="social-icon">
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/Propertynugy"
                      target="_blank"
                    >
                      <img src="assets/images/icon/facebook2.svg" />
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/Propertynugy" target="_blank">
                      <img src="assets/images/icon/twitter.svg" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/Propertynugy"
                      target="_blank"
                    >
                      <img src="assets/images/icon/instagram.svg" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/@Propertynugy"
                      target="_blank"
                    >
                      <img src="assets/images/icon/youtube.svg" />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="appstore d-flex flex-row gap-2">
                <a
                  href="https://play.google.com/store/apps/details?id=com.esp.propertynu"
                  target="_blank"
                >
                  <img src="assets/images/icon/playstore.png" />
                </a>
                <a
                  href="https://apps.apple.com/us/app/propertynu/id6499588778"
                  target="_blank"
                >
                  <img src="assets/images/icon/ios.png" />
                </a>

              </div>
            </Col>

            <Col lg={9}>
              <Row>
                <Col lg={3}>
                  <div className="footer-block mt-4">
                    <ul>
                      <li>
                        <h6 className="text-primary mb-3">
                          Accepted Payment Methods
                        </h6>
                      </li>
                      <li className="d-inline-block me-2">
                        <a href="https://www.mmg.gy/" target="_blank" rel="noopener noreferrer">
                          <img
                            src="images/mmg-logo.png"
                            alt="MMG"
                            style={{ height: "25px", marginRight: "8px" }}
                          />
                        </a>
                      </li>
                      <li className="d-inline-block me-2">
                        <a href="https://www.paypal.com/in/home" target="_blank" rel="noopener noreferrer">
                          <img
                            src="images/paypal-logo.png"
                            alt="Paypal"
                            style={{ height: "25px", marginRight: "8px" }}
                          />
                        </a>
                      </li>
                      <li className="d-inline-block me-2">
                        <a href="https://www.visa.co.in/pay-with-visa/find-a-card/credit-cards.html" target="_blank" rel="noopener noreferrer">
                          <img
                            src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg"
                            alt="Visa"
                            style={{ height: "25px", marginRight: "8px" }}
                          />
                        </a>
                      </li>
                      <li className="d-inline-block me-2">
                        <a href="https://www.mastercard.co.in/en-in.html" target="_blank" rel="noopener noreferrer">
                          <img
                            src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png"
                            alt="MasterCard"
                            style={{ height: "25px", marginRight: "8px" }}
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>

                <Col lg={2}>
                  <div className="footer-block mt-4">
                    <ul>
                      <li>
                        <h6 className="text-primary mb-3">
                          PROPERTYNU
                        </h6>
                      </li>
                      <li>
                        <a
                          href={
                            loginData?.length === 0
                              ? `${config.baseurl}userlogin`
                              : `${config.baseurl}staffdashboard/getstarted`
                          }
                        >
                          Getting started
                        </a>
                      </li>
                      <li>
                        <a href={`${config.baseurl}aboutUs`}>About Us</a>
                      </li>
                      {/* <li><a href="#">Blog</a></li> */}
                    </ul>
                  </div>
                </Col>

                <Col lg={2} className="mb-3">
                  <div className="footer-block mt-4">
                    <ul>
                      <li>
                        <h6 className="text-primary mb-3">
                          SUPPORT
                        </h6>
                      </li>
                      <li>
                        <a href={`${config.baseurl}contactus`}>Contact Us</a>
                      </li>
                      {loginData?.id ? (
                        <li>
                          <a
                            href={`${config.baseurl}${config.loginurluser}/ticketmanagement/1`}
                            style={{ cursor: "pointer" }}
                          >
                            Chat support
                          </a>
                        </li>
                      ) : (
                        <li>
                          <a
                            href={`${config.baseurl}userlogin`}
                            style={{ cursor: "pointer" }}
                          >
                            Chat support
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </Col>

                <Col lg={2} className="mb-3">
                  <div className="footer-block mt-4">
                    <ul>
                      <li>
                        <h6 className="text-primary mb-3">
                          POLICIES
                        </h6>
                      </li>
                      <li>
                        <a href={`${config.baseurl}privacyPolicy`}>Privacy Policy</a>
                      </li>
                      <li>
                        <a href={`${config.baseurl}faq`}>Faqs</a>
                      </li>
                      <li>
                        <a href={`${config.baseurl}termsConditions`}>Terms & Conditions</a>
                      </li>
                    </ul>
                  </div>
                </Col>

                <Col lg={3} className="mb-3">
                  <span className="ms-xl-3">
                    <GoogleTranslate />
                  </span>

                  <div className="dropdown">
                    <select
                      value={currency}
                      // onChange={(e) => setCurrency(e.target.value)}
                      onChange={(e) => {
                        setCurrency(e.target.value);
                        window.location.reload();
                      }}
                      className="currencyDropdown w-100"
                      style={{
                        borderRadius: '2rem',
                      }}
                    >
                      <option value="USD">USD</option>
                      <option value="GYD">GYD</option>
                    </select>
                  </div>


                </Col>

              </Row>
            </Col>
          </Row>
          <hr />
          <div className="copyright">
            <Row>
              <Col lg={12} className="mb-3 text-center">
                <div>
                  {/* <div>Copyright © 2024. Designed by : <a style={{textDecoration:"none",color:"#000"}} href='https://propertynu.com' target='_blank'>
                                    PropertyNU</a></div> */}
                  <div>Copyright &copy; {new Date().getFullYear()} Property NU All Rights Reserved.</div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
